import { Routes, Route } from "react-router-dom";
import Access from "../pages/Home";
import ViewToken from "../pages/ViewToken";
import CreateToken from "../pages/CreateToken";
import Update from "../pages/Update";
import Melt from "../pages/Melt";
import Assets from "../pages/Assets";
import AssetDetails from "../pages/AssetDetails";
import Wallet from "../pages/Wallet";
import CreateWallet from "../pages/CreateWallet";
import RegisterIP from "../pages/RegisterIP";

const RoutesMain = () => {

    return (
        <Routes>
            <Route path="/" element={<Access />} />
            <Route path="/create" element={<CreateToken />} />
            <Route path="/update" element={<Update />} />
            <Route path="/viewtoken" element={<ViewToken />} />
            <Route path="/viewtoken/:txidParams" element={<ViewToken />} /> {/* if you want dynamic fallback */}
            <Route path="/viewtoken/:txidParams/:netParams" element={<ViewToken />} /> {/* if you want dynamic fallback */}
            <Route path="/finish" element={<Melt />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/assets/:id" element={<AssetDetails />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/create-wallet" element={<CreateWallet />} />
            <Route path="/register-ip" element={<RegisterIP />} />
        </Routes>
    );
};

export default RoutesMain;